export default {
  mounted() {
    this.scrollToFirstError();
  },
  updated() {
    this.scrollToFirstError();
  },
  scrollToFirstError() {
    const errorSelector = this.el.dataset.errorSelector || '.border-red-400';

    let firstErrorField = document.querySelector(errorSelector);
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
}
